import React, { Component } from 'react';
import Turnstile  from "react-turnstile";


// const CTurnstile = ({ gettoken }) => {
//     const [token, setToken] = useState('')
//     const turnstile = useTurnstile();

//     const handleTurnstile = (token) => {
//         setToken(token);
//         gettoken(token);
//     };
//     return (
//         <>
//              {/* <Turnstile
//                 sitekey={process.env.REACT_APP_TRUNSTILE_SITE_KEY}
//                 refreshExpired="auto"
//                 onTokenChange={handleTurnstile}
//             />  */}
//              <Turnstile
//                 sitekey={process.env.REACT_APP_TRUNSTILE_SITE_KEY}
//                 // onVerify={(token) => {
//                 //     handleTurnstile(token)
//                 // }}
//                 onSuccess={(token) => {
//                     handleTurnstile(token)
//                 }}
//                 refreshExpired="auto"
//             /> 
//         </>
//     );
// }

// export default CTurnstile;

class CTurnstile extends Component {
    constructor(props) {
        super(props);
        this.state = { Ttoken: "" }
    }

    resetToken = () => {
        if (window.turnstile) {
            window.turnstile.reset();
        }
    }

    sendtoken = (token) => {
        this.props.gettoken(token);
    }

    handleTurnstile = (token) => {
        this.setState({ Ttoken: token });
        this.sendtoken(token);
    };

    render() {
        return <Turnstile
            sitekey={process.env.REACT_APP_TRUNSTILE_SITE_KEY}
            onSuccess={(token) => {
                this.handleTurnstile(token)
            }}
            refreshExpired="auto"
        />;
    }
}

export default CTurnstile;
